export interface Property {
  id: string;
  createdAt: number;
  updatedAt: number;
  name: string;
  address: string;
  city: string;
  state: string;
  zipCode: string;
  country?: string;
  countryCode?: string;
  latitude?: number;
  longitude?: number;
  // Metadata fields (optional - may not exist on all properties)
  beds?: number;
  baths?: number;
  yearBuilt?: number;
  sqft?: number;
  lotSize?: string; // e.g., "0.25 acres"
  price?: number;
  /** Where the stored price came from. 'manual' indicates an advisor entered it. */
  priceSource?: PriceSource;
  /** Source-backed property type (e.g. Single Family, Townhome, Condo). */
  propertyType?: string;
  /** AI-generated punchy headline for the HomeHealth "The Read" section. */
  conditionHeadline?: string;
  /** AI-generated blurb contextualising the condition findings distribution. */
  conditionBlurb?: string;
}

export type PriceSource = 'auto' | 'manual' | 'estimated';

export interface UserProperty {
  property: Property;
  isOwned: boolean;
  isFavorite: boolean;
  clientGroupIds?: string[];
}

/** A user who has access to a property via group membership or ownership. */
export interface PropertyUser {
  userId?: string;
  userEmail: string;
  userName: string;
  userPhoneNumber?: number;
}

export const resolveCountryOrDefault = (property: Property) => property.country || 'USA';
export const resolveCountryCodeOrDefault = (property: Property) => property.countryCode || 'US';
